/*
 * fn: fetchGAClientId
 *
 * Fetches the user ID from GA
 *
 */
import ReactGA from 'react-ga4'

import { IS_ANALYTICS_ENABLED } from '@/defs/analytics'

export const fetchGAClientId = () =>
  new Promise<string | undefined>((resolve) => {
    if (!IS_ANALYTICS_ENABLED) return resolve(undefined)
    let settled = false
    const done = (v?: string) => {
      if (!settled) {
        settled = true
        resolve(v)
      }
    }
    ReactGA.ga((tracker: { get: (k: string) => string | undefined }) => done(tracker.get('clientId')))
    setTimeout(() => done(undefined), 500)
  })
